export const PRINT_ROUTE_PATH_PREFIX = "/print/";

export function splitUuidList(raw: string | null | undefined): string[] {
  if (!raw) return [];
  return raw
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
}

export interface PrintRenderScope {
  visibleTestResultIds: string[];
  printableTestUuids: string[];
}

export function resolvePrintRenderScope(
  uuidParam: string | null | undefined,
  compareUuid: string | null | undefined,
): PrintRenderScope {
  const ids = splitUuidList(uuidParam);
  const compare = compareUuid?.trim() || null;

  if (!compare) {
    return { visibleTestResultIds: ids, printableTestUuids: ids };
  }

  return {
    visibleTestResultIds: ids.filter((id) => id !== compare),
    printableTestUuids: ids.includes(compare) ? ids : [...ids, compare],
  };
}

export function isPrintRenderContext(pathname?: string): boolean {
  const path = pathname ?? (typeof window !== "undefined" ? window.location.pathname : null);
  if (!path) return false;
  return path.startsWith(PRINT_ROUTE_PATH_PREFIX);
}
